import { createFileRoute } from '@tanstack/react-router';
import { HealthGoalsScreen } from '../../screens/health/HealthGoals';

export const Route = createFileRoute('/health/goals')({
  component: HealthGoalsScreen,
});
